import plaintextrequest from "@/utils/plaintextrequest";
import request from "@/utils/request";

// 0元购活动

// 0元购游戏信息
export function zeroBuyInfo(data) {
  return plaintextrequest({
    url: "/BlindBox/oyglists",
    method: "post",
    data,
  });
}

//   0元购个人信息
export function zeroBuyUser(data) {
  return plaintextrequest({
    url: "/BlindBox/oyguser",
    method: "post",
    data,
  });
}

// 0元购购买
export function zeroBuy(data) {
  return request({
    url: "/BlindBox/oygpay",
    method: "post",
    data,
  });
}

// -----------------------------------------游戏活动抽奖
// 获取活动信息
export function getactivityInfo(data) {
  return plaintextrequest({
    url: "/publicH5/appgactiveindex",
    method: "post",
    data,
  });
}
// 抽奖接口
export function getactivityDraw(data) {
  return plaintextrequest({
    url: "/publicH5/cjgetgift",
    method: "post",
    data,
  });
}

// -----------------------------------------专题游戏九宫格抽奖
export function getGamePrizeInfo(data) {
  return plaintextrequest({
    url: "/publicH5/gamePrizeInfo",
    method: "post",
    data,
  });
}

export function drawGamePrize(data) {
  return plaintextrequest({
    url: "/publicH5/gamePrizeDraw",
    method: "post",
    data,
  });
}

export function completeGamePrizeTask(data) {
  return plaintextrequest({
    url: "/publicH5/gamePrizeTask",
    method: "post",
    data,
  });
}

// ------------------------------------------囤币接口
export function getactivityCoin(data) {
  return request({
    url: "/publicH5/fridayFanli",
    method: "post",
    data,
  });
}

// 领取囤币奖励
export function getactivityCoinReward(data) {
  return request({
    url: "/publicH5/getFridayFanli",
    method: "post",
    data,
  });
}

// ------------------------------------------邀请活动
export function getInvite(data) {
  return request({
    url: "/publicH5/yaoqing",
    method: "post",
    data,
  });
}
// 领取邀请奖励
export function getInviteReward(data) {
  return request({
    url: "/publicH5/getyaoqing",
    method: "post",
    data,
  });
}

// ------------------------------------------圣诞活动
export function getChristmas(data) {
  return request({
    url: "/publicH5/christmasActivities",
    method: "post",
    data,
  });
}

// 圣诞活动领券
export function getChristmasCoupon(data) {
  return request({
    url: "/publicH5/getChristmasCoupon",
    method: "post",
    data,
  });
}

// -------------------------------------------元旦活动
// 获取列表
export function getNewYearList(data) {
  return request({
    url: "/publicH5/activityLists",
    method: "post",
    data,
  });
}
// 领取每天奖励
export function getNewYearDailyRewards(data) {
  return request({
    url: "/publicH5/getDailyRewards",
    method: "post",
    data,
  });
}

// 领取任务奖励
export function getNewYearTaskRewards(data) {
  // console.log(data);
  return request({
    url: "/publicH5/getTaskRewards",
    method: "post",
    data,
  });
}
// 单抽
export function getNewYearSingle(data) {
  return request({
    url: "/publicH5/activityChoujiang",
    method: "post",
    data,
  });
}
// 十连抽
export function getNewYearTen(data) {
  return request({
    url: "/publicH5/activityLxChoujiang",
    method: "post",
    data,
  });
}

// 抽奖记录
export function getNewYearRecord(data) {
  return request({
    url: "/publicH5/lotterylog",
    method: "post",
    data,
  });
}

// 是否领取省钱卡活动奖励
export function checkReceivedStatus(data) {
  return plaintextrequest({
    url: "/PublicH5/checkReceivedStatus",
    method: "post",
    data,
  });
}

// 领取
export function receiveShengqianka(data) {
  return plaintextrequest({
    url: "/PublicH5/receiveShengqianka",
    method: "post",
    data,
  });
}

// 双11领取优惠券
export function getS11Coupon(data) {
  return plaintextrequest({
    url: "/publicH5/receiveCoupon",
    method: "post",
    data,
  });
}
export function checkS11Status(data) {
  return plaintextrequest({
    url: "/publicH5/isReceiveCoupon",
    method: "post",
    data,
  });
}


// 特惠包活动
export function sessionlists(data) {
  return plaintextrequest({
    url: "/publicH5/sessionlists",
    method: "post",
    data,
  });
}
export function productLists(data) {
  return request({
    url: "/publicH5/productLists",
    method: "post",
    data,
  });
}
export function activityAlipay(data) {
  return request({
    url: "/publicH5/activityAlipay",
    method: "post",
    data,
  });
}
export function activityWxpay(data) {
  return request({
    url: "/publicH5/activityWxpay",
    method: "post",
    data,
  });
}
export function activityDypay(data) {
  return request({
    url: "/Dypay/activityDypay",
    method: "post",
    data,
  });
}
export function activityOrderLog(data) {
  return plaintextrequest({
    url: "/publicH5/activityOrderLog",
    method: "post",
    data,
  });
}
